import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 11v-2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4","key":"svg-0"}],["path",{"d":"M14 21v-4a2 2 0 1 1 4 0v4","key":"svg-1"}],["path",{"d":"M14 19h4","key":"svg-2"}],["path",{"d":"M21 15v6","key":"svg-3"}]]

const IconInputAi = createReactComponent('outline', 'input-ai', 'InputAi', __iconNode);

export default IconInputAi;